// extracted by mini-css-extract-plugin
export default {"hero":"HeroSection_hero__n08ea","overlay":"HeroSection_overlay__zdmqy","content":"HeroSection_content__8SBfl"};